<template>
    <div v-if="aberto" class="modal-backdrop" @click.self="fechar">
        <div class="modal-card">
            <header class="modal-header">
                <h3>Adicionar produtos à categoria</h3>
                <button class="btn acao-secundaria" @click="fechar" aria-label="Fechar">
                    <i class="fa-solid fa-xmark"></i>
                </button>
            </header>
            <div class="toolbar">
                <input v-model="searchQuery" type="text" placeholder="Buscar por código, nome" class="input" />
                <label class="muted">Selecionados: <b>{{ totalSelecionados }}</b></label>
            </div>
            <div class="tabela-wrap">
                <table class="tabela">
                    <colgroup>
                        <col style="width:42px" />
                        <col style="width:140px" />
                        <col style="width:180px" />
                        <col style="width:220px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th class="th-center">
                                <input type="checkbox" :checked="todaPaginaSelecionada"
                                    :indeterminate="paginaIndeterminada"
                                    @change="toggleSelecionarPagina($event.target.checked)" />
                            </th>
                            <th class="th-nowrap">
                                <span class="th-sort" @click="ordenar('cod')">Código</span>
                                <i class="fa-solid fa-caret-up" v-show="isAsc('cod')"></i>
                                <i class="fa-solid fa-caret-down" v-show="isDesc('cod')"></i>
                            </th>
                            <th class="th-nowrap" colspan="2">
                                <span class="th-sort" @click="ordenar('desc')">Produto</span>
                                <i class="fa-solid fa-caret-up" v-show="isAsc('desc')"></i>
                                <i class="fa-solid fa-caret-down" v-show="isDesc('desc')"></i>
                            </th>
                            <th class="th-nowrap">
                                <span class="th-sort" @click="ordenar('tipo')">Tipo</span>
                                <i class="fa-solid fa-caret-up" v-show="isAsc('tipo')"></i>
                                <i class="fa-solid fa-caret-down" v-show="isDesc('tipo')"></i>
                            </th>
                            <th class="th-nowrap">
                                <span class="th-sort" @click="ordenar('familia_produto')">Família</span>
                                <i class="fa-solid fa-caret-up" v-show="isAsc('familia_produto')"></i>
                                <i class="fa-solid fa-caret-down" v-show="isDesc('familia_produto')"></i>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="carregando">
                            <td colspan="6" class="loading-row">Carregando…</td>
                        </tr>
                        <tr v-else-if="itensPagina.length === 0">
                            <td colspan="6" class="estado-vazio">Nenhum produto encontrado.</td>
                        </tr>
                        <tr v-else v-for="(item, i) in itensPagina" :key="item.id || i" class="tr-item"
                            @click="toggleLinha(item)">
                            <td class="td-center" @click.stop>
                                <input type="checkbox" :checked="estaSelecionado(item)"
                                    :disabled="jaVinculadosSet.has(idKey(item))"
                                    @change="toggleSelecionado(item, $event.target.checked)" />
                            </td>
                            <td class="td-cod">{{ item.cod }}</td>
                            <td colspan="2" class="td-desc" :title="item.desc">{{ item.desc }}</td>
                            <td class="td-nowrap" :title="item.tipo?.nome">{{ item.tipo?.nome ?? '-' }}</td>
                            <td class="td-nowrap" :title="item.familia_produto?.familia_nome"> {{
                                item.familia_produto?.familia_nome ?? '-' }} </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="paginacao">
                <button :disabled="paginaAtual <= 1" @click="irParaPagina(paginaAtual - 1)">
                    <i class="fa-solid fa-chevron-left"></i>
                </button>
                <span>Página <b>{{ paginaAtual }}</b> de <b>{{ ultimaPagina }}</b></span>
                <button :disabled="paginaAtual >= ultimaPagina" @click="irParaPagina(paginaAtual + 1)">
                    <i class="fa-solid fa-chevron-right"></i>
                </button>
            </div>
            <footer class="modal-footer">
                <button class="btn acao-secundaria" @click="fechar">Cancelar</button>
                <button class="btn" :disabled="totalSelecionados === 0" @click="confirmar"> Adicionar {{
                    totalSelecionados }} produto<span v-if="totalSelecionados > 1"></span>
                </button>
            </footer>
        </div>
    </div>
</template>
<script>
import serviceProdutos from '@/services/produtos-service';

export default {
    name: 'ModalSelecionarProdutos',
    props: {
        aberto: { type: Boolean, default: false },
        categoriaAlvo: { type: Object, default: null },
        jaVinculadosIds: { type: Array, default: () => [] },
    },

    data() {
        return {
            produtos: [],
            paginaAtual: 1,
            ultimaPagina: 1,
            searchQuery: '',
            sortKey: null,
            sortDir: null,
            selecionadosMap: {},
            carregando: false,
        };
    },

    computed: {
        jaVinculadosSet() {
            return new Set(this.jaVinculadosIds || []);
        },

        itensPagina() {
            const termo = this.searchQuery.trim().toLowerCase();
            const match = (s) => String(s ?? '').toLowerCase().includes(termo);
            let lista = (this.produtos || []).filter((p) => !this.jaVinculadosSet.has(this.idKey(p)));
            if (termo) {
                lista = lista.filter((p) => match(p.desc) || match(p.cod) || match(p.id));
            }
            if (this.sortKey) {
                const asc = this.sortDir === 'asc';
                const key = this.sortKey;
                const getVal = (it) => {
                    if (key === 'tipo') return it.tipo?.nome?.toLowerCase?.() ?? '';
                    if (key === 'familia_produto') return it.familia_produto?.familia_nome?.toLowerCase?.() ?? '';
                    if (key === 'cod') return String(it.cod ?? it.id ?? '').toLowerCase();
                    return String(it[key] ?? '').toLowerCase();
                };
                lista = [...lista].sort((a, b) => {
                    const A = getVal(a), B = getVal(b);
                    if (A < B) return asc ? -1 : 1;
                    if (A > B) return asc ? 1 : -1;
                    return 0;
                });
            }

            return lista;
        },

        totalSelecionados() {
            return Object.keys(this.selecionadosMap).length;
        },

        todaPaginaSelecionada() {
            return this.itensPagina.length > 0 && this.itensPagina.every((p) => this.estaSelecionado(p) || this.jaVinculadosSet.has(this.idKey(p)));
        },

        paginaIndeterminada() {
            const marcados = this.itensPagina.filter((p) => this.estaSelecionado(p)).length;
            return marcados > 0 && marcados < this.itensPagina.length;
        },
    },

    watch: {
        aberto(val) {
            if (val) {
                this.searchQuery = '';
                this.sortKey = null;
                this.sortDir = null;
                this.selecionadosMap = {};
                this.irParaPagina(1);
            }
        },
        searchQuery() {
            this.irParaPagina(1);
        },
    },

    methods: {

        idKey(p) {
            return p?.produto_cod ?? p?.id ?? p?.cod;
        },

        setReactive(obj, k, v) {
            this.$set ? this.$set(obj, k, v) : (obj[k] = v);
        },
        delReactive(obj, k) {
            this.$delete ? this.$delete(obj, k) : delete obj[k];
        },

        fechar() {
            this.$emit('fechar');
        },

        isAsc(key) {
            return this.sortKey === key && this.sortDir === 'asc';
        },

        isDesc(key) {
            return this.sortKey === key && this.sortDir === 'desc';
        },

        ordenar(key) {
            if (this.sortKey !== key) {
                this.sortKey = key;
                this.sortDir = 'asc';
            } else {
                this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
            }
        },

        estaSelecionado(item) {
            return !!this.selecionadosMap[this.idKey(item)];
        },

        toggleSelecionado(item, checked) {
            const key = this.idKey(item);
            if (this.jaVinculadosSet.has(key)) return;
            if (checked) this.setReactive(this.selecionadosMap, key, item);
            else this.delReactive(this.selecionadosMap, key);
        },

        toggleLinha(item) {
            this.toggleSelecionado(item, !this.estaSelecionado(item));
        },

        toggleSelecionarPagina(checked) {
            this.itensPagina.forEach((item) => this.toggleSelecionado(item, checked));
        },

        async irParaPagina(pagina = 1) {
            try {
                this.carregando = true;

                const temFiltro = !!this.searchQuery.trim();
                let resp;

                if (temFiltro) {
                    const payload = { termo: this.searchQuery, tipo: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] };
                    resp = await serviceProdutos.filtrarProdutos(payload, pagina);
                } else {
                    resp = await serviceProdutos.getProdutos(pagina);
                }

                let lista = [];
                let current = 1;
                let last = 1;

                if (Array.isArray(resp)) {
                    lista = resp;
                } else {
                    const payload = resp?.data && typeof resp.data === 'object' && !Array.isArray(resp.data)
                        ? resp.data
                        : resp;
                    lista = Array.isArray(payload?.data) ? payload.data : Array.isArray(payload) ? payload : [];
                    current = Number(payload?.current_page) || 1;
                    last = Number(payload?.last_page) || 1;
                }

                this.produtos = Array.isArray(lista) ? lista : [];
                this.paginaAtual = current;
                this.ultimaPagina = last;
            } catch (e) {
                console.error('Erro ao carregar produtos:', e);
                this.produtos = [];
                this.paginaAtual = 1;
                this.ultimaPagina = 1;
            } finally {
                this.carregando = false;
            }
        },

        async confirmar() {
            const selecionados = Object.values(this.selecionadosMap);
            if (!selecionados.length || !this.categoriaAlvo?.id) return;

            try {
                const codigos = selecionados.map(this.idKey).filter(Boolean);
                await serviceProdutos.vincularProdutosCategoria(this.categoriaAlvo.id, codigos);
                this.$emit('confirmar', selecionados);
                this.fechar();
            } catch (e) {
                console.error('Erro ao vincular produtos à categoria:', e);
            }
        },
    },
};
</script>
<style scoped>
.modal-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, .4);
    display: grid;
    place-items: center;
    z-index: 999;
}

.modal-card {
    width: min(1100px, 95vw);
    max-height: 90vh;
    background: var(--cor-bg);
    border-radius: 12px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    box-shadow: 0 10px 30px rgba(0, 0, 0, .2);
}

.modal-header,
.modal-footer {
    padding: 12px 16px;
    background: var(--cor-bg);
    border-bottom: 1px solid #eee;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}

.modal-footer {
    border-top: 1px solid #eee;
    border-bottom: 0;
}

.toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 16px;
    border-bottom: 1px solid #f0f0f0;
    flex-wrap: wrap;
}

.tabela-wrap {
    overflow: auto;
    max-height: 60vh;
}

.tabela {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    table-layout: fixed;
}

.tabela th,
.tabela td {
    padding: 8px 10px;
    border-bottom: 1px solid #f1f1f1;
    vertical-align: middle;
    box-sizing: border-box;
}

.tabela thead th {
    background: var(--cor-bg);
    position: sticky;
    top: 0;
    z-index: 1;
}

.th-center,
.td-center {
    text-align: center;
}

.th-nowrap {
    white-space: nowrap;
}

.td-nowrap {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.td-cod {
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
}

.td-desc {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.loading-row,
.estado-vazio {
    text-align: center;
    color: #6b7280;
}

.paginacao {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 10px 16px;
    border-top: 1px solid #f0f0f0;
}

.input {
    padding: 8px 10px;
    border: 1px solid #ddd;
    border-radius: 8px;
    min-width: 280px;
}

.btn {
    border: 1px solid #d1d5db;
    padding: 6px 10px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 0.875rem;
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.muted {
    color: #6b7280;
}

.th-sort {
    cursor: pointer;
    user-select: none;
}
</style>
